const TECHNICAL_MESSAGE_PATTERN = /VUE_APP_|HTTP\s*\d+|keyId|payload|signature|ciphertext|manifest|tenants?\[|lines?\[|unknown_error|probe_failed/i;

function getTenantErrorCode(error) {
	if (!error) {
		return '';
	}
	if (typeof error.code === 'string' && error.code) {
		return error.code;
	}
	if (error.message === 'TENANT_ENDPOINT_MISSING') {
		return 'TENANT_ENDPOINT_MISSING';
	}
	return '';
}

function getDefaultMessageByScene(scene) {
	switch (scene) {
		case 'entry':
			return '租户连接失败，请稍后重试';
		case 'runtime':
			return '当前租户连接异常，请稍后重试';
		case 'reconnect':
			return '当前租户连接异常，正在重试';
		case 'auth':
		default:
			return '当前租户连接失败，请稍后重试';
	}
}

function isUserFacingTenantMessage(message) {
	const normalizedMessage = String(message || '').trim();
	if (!normalizedMessage) {
		return false;
	}
	if (TECHNICAL_MESSAGE_PATTERN.test(normalizedMessage)) {
		return false;
	}
	if (/拉取租户清单失败|租户发现配置缺失|租户清单/.test(normalizedMessage)) {
		return false;
	}
	return true;
}

export function isTenantEndpointError(error) {
	if (!error) {
		return false;
	}
	const code = getTenantErrorCode(error);
	return Boolean(code) || error.name === 'TenantEndpointError';
}

export function resolveTenantErrorMessage(error, scene = 'auth') {
	const code = getTenantErrorCode(error);
	switch (code) {
		case 'TENANT_KEY_REQUIRED':
			return '请输入租户号';
		case 'TENANT_KEY_INVALID':
			return '租户号格式不正确';
		case 'TENANT_NOT_AVAILABLE':
			return scene === 'entry'
				? '租户不存在或不可用'
				: '当前租户不可用，请联系管理员';
		case 'TENANT_SESSION_MISSING':
		case 'TENANT_ENDPOINT_MISSING':
			return scene === 'entry' ? '请输入租户号' : '请先选择租户';
		case 'TENANT_LINES_UNAVAILABLE':
		case 'TENANT_MANIFEST_TIMEOUT':
		case 'TENANT_MANIFEST_FETCH_FAILED':
			if (scene === 'entry' || scene === 'auth') {
				return '租户连接失败，请稍后重试';
			}
			return scene === 'reconnect'
				? '当前租户连接异常，正在重试'
				: '当前租户连接异常，请稍后重试';
		case 'TENANT_DISCOVERY_CONFIG_MISSING':
		case 'TENANT_CONFIG_LOAD_FAILED':
		case 'TENANT_MANIFEST_INVALID':
		case 'TENANT_SIGNATURE_INVALID':
		case 'TENANT_SIGNATURE_UNSUPPORTED':
		case 'TENANT_DECRYPT_INVALID':
		case 'TENANT_DECRYPT_UNSUPPORTED':
		case 'TENANT_UPDATER_CONFIG_MISSING':
			return '租户配置异常，请联系管理员';
		default: {
			const rawMessage = error && error.message ? String(error.message).trim() : '';
			if (isUserFacingTenantMessage(rawMessage)) {
				return rawMessage;
			}
			return getDefaultMessageByScene(scene);
		}
	}
}
